<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="快递名称：">
            <el-input v-model="query.name" placeholder="请输入快递名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="付款方式：">
            <el-select v-model="query.paymentMethod" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="系统收费" :value="1"></el-option>
              <el-option label="到付" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="订货" name="1"></el-tab-pane>
          <el-tab-pane label="秒杀" name="2"></el-tab-pane>
          <el-tab-pane label="积分" name="3"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建快递</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="快递编码" prop="code" align="center" fixed />
        <el-table-column label="快递名称" prop="name" align="center" fixed />
        <el-table-column label="付款方式" prop="paymentMethod" align="center">
          <template slot-scope="{row}">
            {{row.paymentMethod === 1?'系统收费':'到付'}}
          </template>
        </el-table-column>
        <el-table-column label="包邮条件" prop="freeMinAmount" align="center" />
        <el-table-column label="邮费" prop="price" align="center" />
        <el-table-column label="偏远地区邮费" prop="regionFeeListStr" align="center" width="200" show-overflow-tooltip />
        <el-table-column label="不发货地区" prop="noDeliveryRegionsNameListStr" align="center" width="200" show-overflow-tooltip />
        <el-table-column label="描述" prop="remark" align="center" />
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" /> -->
    </el-card>
    <!-- 新建表单 -->
    <express-add ref="expressAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import expressAdd from './add'
import sysExpressApi from '@/api/config/sysExpress'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    expressAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.orderType = +this.activeName
      this.listLoading = true
      return sysExpressApi.fetchList(this.query)
        .then(({ data }) => {
          data.list.forEach(item => {
            item.noDeliveryRegionsNameListStr = item.noDeliveryRegionsNameList && item.noDeliveryRegionsNameList.toString();
            let arr = []
            item.regionFeeList.forEach(it => {
              if (it.regionsNameList) {
                let pri = it.price ? '：' + it.price : ''
                arr.push(it.regionsNameList.toString() + pri + ';')
              }


            })
            item.regionFeeListStr = arr.toString()
          });
          this.list = data.list
          // this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysExpressApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择角色')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysExpressApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysExpressApi.setIsEnableExpress({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.expressAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.expressShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.expressAdd.handleUpdate(row)
    }
  }
}
</script>